import type { Id } from '@e-socna/data-layer';

import type { FolderPage_OneFolder } from '../../../pages/Folder/hooks/useFindOneFolderQuery.hook';
import type { MissionPage_OneMission } from '../../../pages/Mission/hooks/useFindOneMissionQuery.hook';
import type { ResolvableMissionTypePage_OneResolvableMissionType } from '../../../pages/ResolvableMissionType/hooks/useFindOneResolvableMissionTypeQuery.hook';

export enum MissionContextStatus {
  Loading = 'loading',
  NotInitialized = 'notInitialized',
  Ready = 'ready',
  Error = 'error',
}

interface MissionContextLoading {
  readonly status: MissionContextStatus.Loading;
  readonly missionId: Id;
  readonly folderId: Id | undefined;
  readonly resolvableMissionTypeId: undefined;
  readonly mission: undefined;
  readonly folder: FolderPage_OneFolder | undefined;
  readonly resolvableMissionType: undefined;
}

interface MissionContextNotInitialized {
  readonly status: MissionContextStatus.NotInitialized;
  readonly missionId: undefined;
  readonly folderId: undefined;
  readonly resolvableMissionTypeId: undefined;
  readonly mission: undefined;
  readonly folder: undefined;
  readonly resolvableMissionType: undefined;
}

interface MissionContextReady {
  readonly status: MissionContextStatus.Ready;
  readonly missionId: Id;
  readonly folderId: Id;
  readonly resolvableMissionTypeId: Id | null | undefined;
  readonly mission: MissionPage_OneMission;
  readonly folder: FolderPage_OneFolder;
  readonly resolvableMissionType:
    ResolvableMissionTypePage_OneResolvableMissionType | undefined;
  readonly relatedBusinessEntities: Readonly<{
    folder: FolderPage_OneFolder;
    mission: MissionPage_OneMission;
    resolvableMissionType:
      ResolvableMissionTypePage_OneResolvableMissionType | undefined;
  }>;
}

interface MissionContextError {
  readonly status: MissionContextStatus.Error;
  readonly missionId: Id;
  readonly folderId: Id | undefined;
  readonly resolvableMissionTypeId: undefined;
  readonly mission: undefined;
  readonly folder: FolderPage_OneFolder | undefined;
  readonly resolvableMissionType: undefined;
}

export type MissionContextData =
  | MissionContextLoading
  | MissionContextNotInitialized
  | MissionContextReady
  | MissionContextError;
